import { useEffect, useState } from 'react';

interface IdleDeadline {
  didTimeout: boolean;
  timeRemaining: () => number;
}

type IdleCallbackHandle = number;

type RequestIdleCallback = (
  callback: (deadline: IdleDeadline) => void,
  options?: { timeout?: number }
) => IdleCallbackHandle;

type CancelIdleCallback = (handle: IdleCallbackHandle) => void;

export function useIdleReady(delayMs = 1200): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;

    let cancelled = false;
    const win = window as typeof window & {
      requestIdleCallback?: RequestIdleCallback;
      cancelIdleCallback?: CancelIdleCallback;
    };

    const trigger = () => {
      if (!cancelled) setReady(true);
    };

    if (typeof win.requestIdleCallback === 'function') {
      const id = win.requestIdleCallback(() => trigger(), { timeout: delayMs });
      return () => {
        cancelled = true;
        if (typeof win.cancelIdleCallback === 'function') {
          win.cancelIdleCallback(id);
        }
      };
    }

    const timer = window.setTimeout(trigger, delayMs);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [delayMs, ready]);

  return ready;
}
